import React from 'react';
import '../node_modules/bootstrap/dist/css/bootstrap.css'
import './assets/css/animation.css'
import './assets/css/global.css'
import './assets/css/home-page.css'
import './assets/js/global'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Layout from './layouts/Layout';
import Resume from './pages/resume/Resume';
import Portfolio from './pages/portfolio/Portfolio';
import Blog from './pages/blog/Blog';
import ContactUs from './pages/contactUs/ContactUs';
import EnLayout from './layouts/EnLayout ';
import BlogPage from './pages/blog/blogPage';
import $ from 'jquery';
import { useDispatch } from 'react-redux';
import { fetcharticle } from './reducers/resumeSlice';

function App() {
  const dispatch = useDispatch()
  const melan = localStorage.getItem("language")
  $(window).on('load', function () {
    console.log(window.location.hash.split("#")[1]);
    var myArticle = JSON.parse(localStorage.getItem("article"));
    if (myArticle) {
      dispatch(fetcharticle({ article: myArticle }));
      if (window.location.hash) {
        $(".animated-section").removeClass("section-active");
        console.log("heloooooo");
        const myselector = "." + window.location.hash.split("#")[1];
        console.log(myselector);
        $(".L90").addClass("section-active");
        $(".article").addClass("custom-anim");
      }
    }
  })
  return (
    <div className="App">

      <Router>
        <Routes>
          <Route path="/" element={melan === 'Fa' ? <Layout /> : <EnLayout />} >
            {/* <Route path="/article/:id" element={melan === 'Fa' ? <BlogPage /> : <BlogPage />} /> */}
            {/* <Route path="/resume" element={melan === 'Fa' ? <Resume /> : <Resume />} />
            <Route path="/portfolio" element={melan === 'Fa' ? <Portfolio /> : <Portfolio />} />
            <Route path="/blog" element={melan === 'Fa' ? <Blog /> : <Blog />} />
            <Route path="/contact-us" element={melan === 'Fa' ? <ContactUs /> : <ContactUs />} />  */}
          </Route>
        </Routes>
      </Router>

    </div >
  );
}

export default App;
